import React from 'react';
import './GlobalLoader.css'; 

const GlobalLoader = ({ isLoading, message = '' }) => {
  if (!isLoading) {
    return null;
  }

  return (
    <div className="loading-overlay">
      <div className="loading-box">
        <div className="sequential-spinners-container">
          <div className="spinner-grow text-primary" role="status"></div>
          <div className="spinner-grow text-secondary" role="status"></div>
          <div className="spinner-grow text-success" role="status"></div>
          <div className="spinner-grow text-danger" role="status"></div>
          <div className="spinner-grow text-warning" role="status"></div>
          {/* <div className="spinner-grow text-info" role="status"></div>
          <div className="spinner-grow text-light" role="status"></div>
          <div className="spinner-grow text-dark" role="status"></div> */}
        </div>
        {message && <span className="loading-text">{message}</span>}
      </div>
    </div>
  );
};

export default GlobalLoader;